import colorMod from 'color';

export default ({ color, fontSize, typography }) => ({
  metricTypeBox: {
    border: `1px solid ${color.primaryButtonBackground}`,
    width: 'auto',
    whiteSpace: 'nowrap',
    padding: '10px 0px 10px 0',
    display: 'inline-block',
    background: color.primaryButtonText,
    borderRadius: 3,
    justifyContent: 'center',
    alignItems: 'center',
    color: color.primaryButtonBackground,
    fontFamily: typography.buttonText,
    fontSize: fontSize.buttonText,
    '&:hover': {
      background: `${colorMod(color.primaryButtonText).alpha(0.05).string()} !important`,
    },
    '@media print': {
      border: '0px solid #C8D1E0',
      color: '#000',
      fontWeight: 'normal',
    },
  },
  filterLabelContainer: {
    position: 'relative',
    width: 'auto',
    border: 'none',
    color: color.primaryButtonBackground,
    fontFamily: typography.buttonText,
    fontSize: fontSize.buttonText,
    height: 'auto',
    alignItems: 'center',
    cursor: 'pointer',
    display: 'inline-flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginRight: 18,
    marginLeft: 10,
    '@media print': {
      border: '0px solid #C8D1E0',
      color: '#000',
      paddingTop: 0,
      fontSize: 12,
      fontWeight: 'normal',
      marginRight: 5,
      marginTop: 0,
      marginLeft: 0,
    },
  },

  metricCountContainer: {
    borderRadius: '50%',
    width: 18,
    textAlign: 'center',
    display: 'inline-block',
    border: `1px solid ${color.primaryButtonBackground}`,
    background: color.primaryButtonBackground,
    color: color.primaryButtonText,
    marginLeft: 7,
  },
  arrow: {
    padding: 14,
    display: 'inline',
    position: 'absolute',
    right: -15,
    bottom: -4,
    borderRadius: 3,
    border: `1px solid ${color.primaryButtonBackground}`,
    borderLeft: 'transparent',
    borderBottom: 'transparent',
    transform: 'rotate(45deg)',
    '@media print': {
      display: 'none',
    },
  },
});